export const GROUPS = {
  CASINO: 'CASINO',
  LIVE: 'LIVE',
  TVGAMES: 'TVGAMES',
};

export const GAME_SIZES = {
  LARGE: 'L',
  MEDIUM: 'M',
  SMALL: 'S',
};

export const GAMES_IN_ROW_BY_SIZE = {
  [GAME_SIZES.LARGE]: 4,
  [GAME_SIZES.MEDIUM]: 5,
  [GAME_SIZES.SMALL]: 6,
};

export const GAMES_IN_ROW_BY_SIZE_FOR_FULL_WIDTH = {
  [GAME_SIZES.LARGE]: 5,
  [GAME_SIZES.MEDIUM]: 6,
  [GAME_SIZES.SMALL]: 7,
};

export const GAMES_IN_COLUMN_BY_SIZE = {
  [GAME_SIZES.LARGE]: 1,
  [GAME_SIZES.MEDIUM]: 2,
  [GAME_SIZES.SMALL]: 1,
};

export const GAME_TILE_VIEW_HEIGHT = {
  'View 1': 150,
  'View 2': 180,
  'View 3': 180,
  'View 4': 222,
  'View 5': 226,
};
